import ResourceCrudPage, {
  Field,
  TextInput,
  TextArea,
  NumberInput,
} from "./ResourceCrudPage";

export default function AdminAnnouncementsPage() {
  return (
    <ResourceCrudPage
      resource="announcements"
      title="Announcements"
      subtitle="Banner shown at the very top of every page. Leave dates blank for no schedule constraints."
      testIdPrefix="announcements"
      blank={() => ({
        message: "",
        link_label: "",
        link_url: "",
        active: true,
        start_date: "",
        end_date: "",
        display_order: 100,
      })}
      validate={(f) =>
        !f.message?.trim()
          ? { ok: false, message: "Message is required." }
          : { ok: true }
      }
      renderRow={(item) => (
        <div>
          <p className="font-display font-bold text-slate-900 truncate">
            {item.message}
          </p>
          <p className="text-xs text-slate-500 mt-1 truncate">
            {item.start_date || "no start"} → {item.end_date || "no end"}
            {item.link_url ? ` · ${item.link_label || "Link"}` : ""}
          </p>
        </div>
      )}
      renderForm={({ form, setField }) => (
        <>
          <Field label="Message">
            <TextInput
              value={form.message}
              onChange={setField("message")}
              data-testid="announcements-form-message"
            />
          </Field>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Link label (optional)">
              <TextInput
                value={form.link_label}
                onChange={setField("link_label")}
              />
            </Field>
            <Field label="Link URL (optional)">
              <TextInput
                value={form.link_url}
                onChange={setField("link_url")}
              />
            </Field>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Start date (optional)" hint="ISO format: YYYY-MM-DDTHH:MM">
              <input
                type="datetime-local"
                className="input-soft"
                value={form.start_date || ""}
                onChange={(e) => setField("start_date")(e.target.value)}
              />
            </Field>
            <Field label="End date (optional)">
              <input
                type="datetime-local"
                className="input-soft"
                value={form.end_date || ""}
                onChange={(e) => setField("end_date")(e.target.value)}
              />
            </Field>
          </div>
          <Field label="Display order (when multiple are active)">
            <NumberInput
              value={form.display_order}
              onChange={setField("display_order")}
            />
          </Field>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={!!form.active}
              onChange={(e) => setField("active")(e.target.checked)}
            />
            Active
          </label>
        </>
      )}
    />
  );
}
